import { render, staticRenderFns } from "./ViewWebshopBlock.vue?vue&type=template&id=8a054a36&scoped=true&"
import script from "./ViewWebshopBlock.vue?vue&type=script&lang=js&"
export * from "./ViewWebshopBlock.vue?vue&type=script&lang=js&"
import style0 from "./ViewWebshopBlock.vue?vue&type=style&index=0&id=8a054a36&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a054a36",
  null
  
)

export default component.exports